'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var tempdir = require('ipfs-utils/src/temp-dir');

exports.filter = function (iterable, filterer) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, keep;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(iterable);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 10;
            return _awaitAsyncGenerator(_step.value);

          case 10:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 23;
              break;
            }

            value = _value;
            _context.next = 15;
            return _awaitAsyncGenerator(filterer(value));

          case 15:
            keep = _context.sent;

            if (keep) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("continue", 20);

          case 18:
            _context.next = 20;
            return value;

          case 20:
            _iteratorNormalCompletion = true;
            _context.next = 4;
            break;

          case 23:
            _context.next = 29;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 29:
            _context.prev = 29;
            _context.prev = 30;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 34;
              break;
            }

            _context.next = 34;
            return _awaitAsyncGenerator(_iterator.return());

          case 34:
            _context.prev = 34;

            if (!_didIteratorError) {
              _context.next = 37;
              break;
            }

            throw _iteratorError;

          case 37:
            return _context.finish(34);

          case 38:
            return _context.finish(29);

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
  }))();
}; // Not just sort, because the sorter is given all the values and should return
// them all sorted


exports.sortAll = function (iterable, sorter) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var values, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, value, _iterator5, _step5, _value5;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            values = [];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context2.prev = 3;
            _iterator2 = _asyncIterator(iterable);

          case 5:
            _context2.next = 7;
            return _awaitAsyncGenerator(_iterator2.next());

          case 7:
            _step2 = _context2.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context2.next = 11;
            return _awaitAsyncGenerator(_step2.value);

          case 11:
            _value2 = _context2.sent;

            if (_iteratorNormalCompletion2) {
              _context2.next = 18;
              break;
            }

            value = _value2;
            values.push(value);

          case 15:
            _iteratorNormalCompletion2 = true;
            _context2.next = 5;
            break;

          case 18:
            _context2.next = 24;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 24:
            _context2.prev = 24;
            _context2.prev = 25;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context2.next = 29;
              break;
            }

            _context2.next = 29;
            return _awaitAsyncGenerator(_iterator2.return());

          case 29:
            _context2.prev = 29;

            if (!_didIteratorError2) {
              _context2.next = 32;
              break;
            }

            throw _iteratorError2;

          case 32:
            return _context2.finish(29);

          case 33:
            return _context2.finish(24);

          case 34:
            _context2.next = 36;
            return _awaitAsyncGenerator(sorter(values));

          case 36:
            values = _context2.sent;
            _iterator5 = _createForOfIteratorHelper(values);
            _context2.prev = 38;

            _iterator5.s();

          case 40:
            if ((_step5 = _iterator5.n()).done) {
              _context2.next = 46;
              break;
            }

            _value5 = _step5.value;
            _context2.next = 44;
            return _value5;

          case 44:
            _context2.next = 40;
            break;

          case 46:
            _context2.next = 51;
            break;

          case 48:
            _context2.prev = 48;
            _context2.t1 = _context2["catch"](38);

            _iterator5.e(_context2.t1);

          case 51:
            _context2.prev = 51;

            _iterator5.f();

            return _context2.finish(51);

          case 54:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 20, 24, 34], [25,, 29, 33], [38, 48, 51, 54]]);
  }))();
};

exports.take = function (iterable, n) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var i, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, value;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(n <= 0)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            i = 0;
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _context3.prev = 5;
            _iterator3 = _asyncIterator(iterable);

          case 7:
            _context3.next = 9;
            return _awaitAsyncGenerator(_iterator3.next());

          case 9:
            _step3 = _context3.sent;
            _iteratorNormalCompletion3 = _step3.done;
            _context3.next = 13;
            return _awaitAsyncGenerator(_step3.value);

          case 13:
            _value3 = _context3.sent;

            if (_iteratorNormalCompletion3) {
              _context3.next = 24;
              break;
            }

            value = _value3;
            _context3.next = 18;
            return value;

          case 18:
            i++;

            if (!(i >= n)) {
              _context3.next = 21;
              break;
            }

            return _context3.abrupt("return");

          case 21:
            _iteratorNormalCompletion3 = true;
            _context3.next = 7;
            break;

          case 24:
            _context3.next = 30;
            break;

          case 26:
            _context3.prev = 26;
            _context3.t0 = _context3["catch"](5);
            _didIteratorError3 = true;
            _iteratorError3 = _context3.t0;

          case 30:
            _context3.prev = 30;
            _context3.prev = 31;

            if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
              _context3.next = 35;
              break;
            }

            _context3.next = 35;
            return _awaitAsyncGenerator(_iterator3.return());

          case 35:
            _context3.prev = 35;

            if (!_didIteratorError3) {
              _context3.next = 38;
              break;
            }

            throw _iteratorError3;

          case 38:
            return _context3.finish(35);

          case 39:
            return _context3.finish(30);

          case 40:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 26, 30, 40], [31,, 35, 39]]);
  }))();
};

exports.map = function (iterable, mapper) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _value4, value;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _context4.prev = 2;
            _iterator4 = _asyncIterator(iterable);

          case 4:
            _context4.next = 6;
            return _awaitAsyncGenerator(_iterator4.next());

          case 6:
            _step4 = _context4.sent;
            _iteratorNormalCompletion4 = _step4.done;
            _context4.next = 10;
            return _awaitAsyncGenerator(_step4.value);

          case 10:
            _value4 = _context4.sent;

            if (_iteratorNormalCompletion4) {
              _context4.next = 18;
              break;
            }

            value = _value4;
            _context4.next = 15;
            return mapper(value);

          case 15:
            _iteratorNormalCompletion4 = true;
            _context4.next = 4;
            break;

          case 18:
            _context4.next = 24;
            break;

          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](2);
            _didIteratorError4 = true;
            _iteratorError4 = _context4.t0;

          case 24:
            _context4.prev = 24;
            _context4.prev = 25;

            if (!(!_iteratorNormalCompletion4 && _iterator4.return != null)) {
              _context4.next = 29;
              break;
            }

            _context4.next = 29;
            return _awaitAsyncGenerator(_iterator4.return());

          case 29:
            _context4.prev = 29;

            if (!_didIteratorError4) {
              _context4.next = 32;
              break;
            }

            throw _iteratorError4;

          case 32:
            return _context4.finish(29);

          case 33:
            return _context4.finish(24);

          case 34:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 20, 24, 34], [25,, 29, 33]]);
  }))();
};

exports.replaceStartWith = function (s, r) {
  var matcher = new RegExp('^' + r);
  return s.replace(matcher, '');
};

exports.tmpdir = tempdir;